import React from "react";
import { testimonials } from "../utiles/constant";
import { StarIcon } from "../assets/icons";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const TestimonialList = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="flex-1 min-w-[300px] lg:w-1/2 z-100 bg-white py-10">
      <div className="space-y-6 flex flex-col lg:pl-24" ref={ref}>
        {testimonials.map((testimonial, index) => {
          const direction = index % 2 === 0 ? "left" : "right";

          return (
            <motion.div
              key={index}
              className="bg-gray-200 p-4 md:p-6 rounded-lg shadow-card-border"
              initial={{ x: direction === "left" ? "-90%" : "90%", opacity: 0 }}
              animate={{
                x: inView ? 0 :1,
                opacity: inView ? 1 : 0,
              }}
              transition={{ duration: 1, delay: index * 0.2 }}
            >
              <p className="text-gray-500 italic text-sm sm:text-sm md:text-sm lg:text-lg">
                {testimonial.text}
              </p>
              <div className="flex mt-8 mb-2">
                {[...Array(5)].map((_, i) => (
                  <StarIcon key={i} />
                ))}
              </div>
              <h3 className="text-sm sm:text-xs md:text-xs lg:text-base text-primary font-semibold italic">
                {testimonial.author}
                <span className="text-xs sm:text-xs md:text-[8px] lg:text-xs text-gray-500 ml-2">
                  {testimonial.position}
                </span>
              </h3>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default TestimonialList;
